// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__awWB4","modalOverlay":"Modal_modalOverlay__SLCUm"};